import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import * as API from "../../Endpoints/Endpoints"; // Ensure your cube endpoints are here

const ViewCube = () => {
  const [cubeData, setCubeData] = useState(null);
  const { cubeid } = useParams();
  const navigate = useNavigate();

  // Fetch cube data by ID
  useEffect(() => {
    const getCubeData = async () => {
      try {
        const response = await axios.get(API.GET_CUBE_BYID(cubeid));
        setCubeData(response.data);
      } catch (error) {
        console.error("Error fetching cube data:", error);
      }
    };

    if (cubeid) {
      getCubeData();
    }
  }, [cubeid]);

  // Handle cube deletion
  const deleteCube = async (cubeid) => {
    if (!window.confirm("Are you sure you want to delete this Cube entry?")) return;
    try {
      await axios.delete(API.DELETE_CUBE_API(cubeid));
      console.log("Deleting Cube ID:", cubeid);
      alert("Cube Game entry deleted successfully");
      navigate("/cubemaster");
    } catch (error) {
      console.error("Error deleting Cube entry:", error.response?.data || error.message);
      alert("Failed to delete Cube entry");
    }
  };

  // Navigate back to cube table
  const goBack = () => {
    navigate("/cubemaster");
  };

  return (
    <div className="py-16 bg-[#f5f5f5] h-full">
      <div className="container px-6 m-auto text-gray-700 md:px-12 xl:px-0">
        <div className="grid gap-6 mx-auto md:w-3/6 lg:w-full lg:grid-cols-1">
          <div className="bg-white rounded-2xl shadow-lg px-8 py-12 sm:px-12 lg:px-8">
            <div className="mb-12 space-y-6">
              {cubeData ? (
                <div>
                  <h5 className="text-2xl font-semibold text-[#e64a32]">
                    Cube Game Details
                  </h5>
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                    <div className="flex flex-col">
                      <span className="font-bold">Religion</span>
                      <span>{cubeData.religion || "N/A"}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Theme</span>
                      <span>{cubeData.theme || "N/A"}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Type</span>
                      <span>{cubeData.type || "N/A"}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Passion Dimension</span>
                      <span>{cubeData.passiondimension || "N/A"}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Question</span>
                      <span>{cubeData.question || "N/A"}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Related SDG</span>
                      <span>{cubeData.relatedSDG || "N/A"}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Age Group</span>
                      <span>{cubeData.agegroup || "N/A"}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Known Religious Lead</span>
                      <span>{cubeData.knownreligiouslead || "N/A"}</span>
                    </div>
                    <div className="flex flex-col col-span-1 sm:col-span-2 md:col-span-3 lg:col-span-4">
                      <span className="font-bold">Brief Description of Lead</span>
                      <span>{cubeData.briefdescriptionoflead || "N/A"}</span>
                    </div>
                  </div>

                  <div className="flex items-center justify-center mt-6 space-x-4">
                    <button
                      className="bg-[#e64a32] text-white hover:bg-[#c5382e] font-bold py-2 px-4 rounded"
                      onClick={() => deleteCube(cubeData.cubeid)}
                    >
                      Delete
                    </button>
                    <button
                      className="bg-[#e64a32] hover:bg-[#c5382e] text-white font-bold py-2 px-4 rounded"
                      onClick={goBack}
                    >
                      &#8592; Go Back
                    </button>
                  </div>
                </div>
              ) : (
                <p className="text-center text-gray-500">Loading Cube details...</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewCube;
